import { ActivatedRoute, Router } from '@angular/router';
import { Empresa } from './../../components/interfaces/empresa.entity';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainComponent implements OnInit {

  mensaje: string;

  empresa: Empresa;
  resultado: any[];

  

  constructor(private ref:ChangeDetectorRef, private route:ActivatedRoute, private router: Router, private vps: ViewportScroller) {

    // this.actualizarRutas();

   }

async  actualizarRutas() {

await  this.router.events.subscribe(

    (val: any) => {

      this.resultado = val;

      if (this.resultado["url"] === "/home") {

       this.mensaje =this.resultado["url"];


      } else {

        this.mensaje = '';
        this.empresa = JSON.parse(sessionStorage.getItem('empresa'));

      }


    }


  );



 }

  ngOnInit() {

    this.empresa = JSON.parse(sessionStorage.getItem('empresa'));


    this.actualizarRutas();

    //
  }




}
